// Initialize GLightbox for custom product thumbnails
(function () {
  'use strict';

  // Track initialized galleries to prevent duplicate initialization
  const initializedGalleries = new Set();
  let initAttempts = 0;
  const maxInitAttempts = 50; // 5 seconds max wait

  // Wait for GLightbox to load
  function waitForGLightbox(callback) {
    if (typeof GLightbox !== 'undefined') {
      callback();
      return;
    }

    initAttempts++;
    if (initAttempts >= maxInitAttempts) {
      console.error('GLightbox failed to load after maximum attempts');
      return;
    }

    setTimeout(() => waitForGLightbox(callback), 100);
  }

  // Initialize GLightbox for a specific gallery
  function initGallery(galleryId) {
    // Skip if already initialized
    if (initializedGalleries.has(galleryId)) {
      return;
    }

    const galleryLinks = document.querySelectorAll(`[data-glightbox="${galleryId}"]`);

    if (galleryLinks.length === 0) {
      return;
    }

    // Mark as initialized before creating the instance
    initializedGalleries.add(galleryId);

    try {
      const lightbox = GLightbox({
        selector: `[data-glightbox="${galleryId}"]`,
        touchNavigation: true,
        loop: true,
        autoplayVideos: false,
        closeButton: true,
        closeOnOutsideClick: true,
        dragAutoSnap: false,
        openEffect: 'fade',
        closeEffect: 'fade',
        slideEffect: 'slide',
        zoomable: true,
        moreText: 'See more',
        moreLength: 60,
        onOpen: () => {
          document.body.style.overflow = 'hidden';
        },
        onClose: () => {
          document.body.style.overflow = '';
        },
      });
    } catch (error) {
      console.error('Error initializing GLightbox for gallery:', galleryId, error);
      initializedGalleries.delete(galleryId); // Allow retry on error
    }
  }

  // Initialize all galleries
  function initAllGalleries() {
    waitForGLightbox(() => {
      // Small delay to ensure all lazy-loaded images are in DOM
      setTimeout(() => {
        // Find all unique gallery IDs
        const galleryLinks = document.querySelectorAll('[data-glightbox^="gallery-"]');
        const galleryIds = new Set();

        galleryLinks.forEach((link) => {
          const galleryId = link.getAttribute('data-glightbox');
          if (galleryId) {
            galleryIds.add(galleryId);
          }
        });

        // Initialize each gallery
        galleryIds.forEach((galleryId) => {
          initGallery(galleryId);
        });
      }, 100);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllGalleries);
  } else {
    initAllGalleries();
  }

  // Re-initialize for dynamically added content
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver((mutations) => {
      const newGalleryIds = new Set();

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return; // Only element nodes

          // Check if node itself has data-glightbox
          if (node.hasAttribute && node.hasAttribute('data-glightbox')) {
            const galleryId = node.getAttribute('data-glightbox');
            if (galleryId && galleryId.startsWith('gallery-')) {
              newGalleryIds.add(galleryId);
            }
          }

          // Check for nested elements with data-glightbox
          if (node.querySelectorAll) {
            const nestedLinks = node.querySelectorAll('[data-glightbox^="gallery-"]');
            nestedLinks.forEach((link) => {
              const galleryId = link.getAttribute('data-glightbox');
              if (galleryId) {
                newGalleryIds.add(galleryId);
              }
            });
          }
        });
      });

      // Initialize any new galleries
      if (newGalleryIds.size > 0) {
        waitForGLightbox(() => {
          newGalleryIds.forEach((galleryId) => {
            initGallery(galleryId);
          });
        });
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();
